import { useState, useEffect } from "react"
import axios from "axios"
import { useSelector } from "react-redux"

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BASE_URL = process.env.REACT_APP_API_BASE_URL

const BillingSettings = () => {
  const accessToken = useSelector((state) => state.auth.access)

  const [billingData, setBillingData] = useState({
    id: null,
    first_name: "",
    last_name: "",
    email: "",
    country: "",
    state: "",
    city: "",
    postcode: "",
    phone: "",
    address: "",
  })

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchBilling = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/users/billing-address/`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        })
        if (response.data.length > 0) {
          setBillingData(response.data[0])
        }
      } catch (error) {
        //console.log("No billing address found or error:", error)
      }
    }
    if (accessToken) fetchBilling()
  }, [accessToken])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setBillingData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    const url = `${BASE_URL}/users/billing-address/`
    const method = billingData.id ? "put" : "post"
    const endpoint = billingData.id ? `${url}${billingData.id}/` : url

    try {
      await axios[method](endpoint, billingData, {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      toast.success("Billing address saved successfully!")
    } catch (error) {
      toast.error("Failed to save billing address.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="billing-settings">
      <h5 className="mb-4">Billing Address</h5>

      <form onSubmit={handleSubmit} key={billingData.id || "new"}>
        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="first_name" className="form-label">First Name</label>
            <input
              type="text"
              className="form-control"
              id="first_name"
              name="first_name"
              value={billingData.first_name || ""}
              onChange={handleInputChange}
              placeholder="First Name"
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="last_name" className="form-label">Last Name</label>
            <input
              type="text"
              className="form-control"
              id="last_name"
              name="last_name"
              value={billingData.last_name || ""}
              onChange={handleInputChange}
              placeholder="Last Name"
              required
            />
          </div>
        </div>

        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email Address</label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            value={billingData.email || ""}
            onChange={handleInputChange}
            placeholder="Email"
            required
          />
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="country" className="form-label">Country</label>
            <input
              type="text"
              className="form-control"
              id="country"
              name="country"
              value={billingData.country || ""}
              onChange={handleInputChange}
              placeholder="Country"
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="state" className="form-label">State</label>
            <input
              type="text"
              className="form-control"
              id="state"
              name="state"
              value={billingData.state || ""}
              onChange={handleInputChange}
              placeholder="State"
              required
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="city" className="form-label">City</label>
            <input
              type="text"
              className="form-control"
              id="city"
              name="city"
              value={billingData.city || ""}
              onChange={handleInputChange}
              placeholder="City"
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="postcode" className="form-label">Postcode</label>
            <input
              type="text"
              className="form-control"
              id="postcode"
              name="postcode"
              value={billingData.postcode || ""}
              onChange={handleInputChange}
              placeholder="Postcode"
              required
            />
          </div>
        </div>

        <div className="mb-3">
          <label htmlFor="phone" className="form-label">Phone</label>
          <input
            type="tel"
            className="form-control"
            id="phone"
            name="phone"
            value={billingData.phone || ""}
            onChange={handleInputChange}
            placeholder="Phone"
            required
          />
        </div>

        <div className="mb-4">
          <label htmlFor="address" className="form-label">Address</label>
          <input
            type="text"
            className="form-control"
            id="address"
            name="address"
            value={billingData.address || ""}
            onChange={handleInputChange}
            placeholder="Address"
            required
          />
        </div>

        <button type="submit" className="btn btn-warning" disabled={loading}>
          {loading ? "Saving..." : "Save Address"}
        </button>
      </form>
    </div>
  )
}

export default BillingSettings
